import { isEscEvent, isTabEvent } from "./utils.js";
import { scrollUp } from "./scroll-up.js";

const MODAL_WRAPPER_CLASS ='modal__wrapper';
const MODAL_CLOSE_BTN_CLASS = 'modal__close-btn';

const body = document.querySelector('.page__body');
const fixedElements = [scrollUp];
let prevModal;

const initModal = (modalElement, beforeOpen, afterClose) => {
  const modalWrapper = modalElement.querySelector(`.${MODAL_WRAPPER_CLASS}`);
  const id = modalElement.getAttribute('id');
  const modalOpenBtns = document.querySelectorAll(`[data-modal="#${id}"]`);
  const modalCloseBtns = document.querySelectorAll(`.${MODAL_CLOSE_BTN_CLASS}`);
  let isOpened = false;

  const openModal = () => {
    if(isOpened) {
      return;
    }

    if (prevModal) {
      prevModal.close();
    }

    if (beforeOpen) {
      beforeOpen();
    }

    prevModal = modal;
    isOpened = true;

    modalElement.showModal();
    controlListener();
    controlElementScroll();
  }

  const closeModal = () => {
    if(!isOpened) {
      return;
    }

    prevModal = null;
    isOpened = false;

    modalElement.close();
    controlListener();
    controlElementScroll();

    if (afterClose) {
      afterClose();
    }
  }

  const controlListener = () => {
    if(isOpened) {
      document.addEventListener(`keydown`, onEscKeyDown);
      document.addEventListener('mousedown', onMouseDown);
      document.addEventListener('mouseup', onMouseUp);
    }

    if (!isOpened) {
      document.removeEventListener('keydown', onEscKeyDown);
      document.removeEventListener('mousedown', onMouseDown);
      document.removeEventListener('mouseup', onMouseUp);
    }
  }

  const controlElementScroll = () => {
    if (isOpened) {
      const scrollYWidth = window.innerWidth - document.documentElement.clientWidth;

      body.style.overflowY = 'hidden';
      body.style.marginRight = `${scrollYWidth}px`;
      modalWrapper.style.marginRight = `${scrollYWidth}px`;

      if (fixedElements) {
        fixedElements.forEach(element => {
          element.style.marginRight = `${scrollYWidth}px`;
        })
      }
    }

    if (!isOpened) {
      body.style.overflowY = '';
      body.style.marginRight = '';
      modalWrapper.style.marginRight = ``;

      if (fixedElements) {
        fixedElements.forEach(element => {
          element.style.marginRight = ``;
        })
      }
    }
  }

  const onEscKeyDown = (evt) => {
    if (isEscEvent(evt)) {
      evt.preventDefault();
      closeModal();
    }
  };

  let isOverlayClick = false;

  const onMouseDown = (evt) => {
    if (modalElement.contains(evt.target) && !modalWrapper.contains(evt.target)) {
      isOverlayClick = true;
    }
  }

  const onMouseUp = (evt) => {
    if (modalElement.contains(evt.target) && !modalWrapper.contains(evt.target) && isOverlayClick) {
      evt.preventDefault();
      closeModal();
      isOverlayClick = false;
    }
  }

  modalOpenBtns.forEach(btn => {
    btn.addEventListener('click', (evt) => {
      openModal();
    })
  })

  modalCloseBtns.forEach(btn => {
    btn.addEventListener('click', (evt) => {
      evt.preventDefault();
      closeModal();
    })
  })

  const modal = {
    element: modalElement,
    isOpened: isOpened,
    close() {closeModal()},
    open() {openModal()},
  }

  return modal;
}

export {initModal};
